// // Footer.js
// import React from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// const Footer = () => {
//   return (
//     <footer className="main-footer bg-section">
//       <div className="container">
//         <div className="row">
//           {/* About Footer */}
//           <div className="col-lg-3">
//             <div className="about-footer">
//               <div className="footer-logo">
//                 <img src="images/footer-logo.svg" alt="Novaride Logo" />
//               </div>
//               <div className="about-footer-content">
//                 <p>
//                   Experience the ease and convenience of renting a car with
//                   Novaride.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Legal Policy */}
//           <div className="col-lg-3 col-md-4">
//             <div className="footer-links footer-quick-links">
//               <h3>legal policy</h3>
//               <ul>
//                 <li>
//                   <a href="Corporate-Bus-Service-in-Mumbai">Corporate Bus Service in Mumbai</a>
//                 </li>
//  <li>
//                   <a href="Best-car-rental-services">Best car rental services</a>
//                 </li>

//                 <li>
//                   <a href="#">privacy policy</a>
//                 </li>
//                 <li>
//                   <a href="#">legal notice</a>
//                 </li>
//                 <li>
//                   <a href="#">accessibility</a>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* Quick Links */}
//           <div className="col-lg-3 col-md-4">
//             <div className="footer-links footer-menu">
//               <h3>quick links</h3>
//               <ul>
//                 <li>
//                   <a href="#">home</a>
//                 </li>
//                 <li>
//                   <a href="#">about us</a>
//                 </li>
//                 <li>
//                   <a href="#">cars</a>
//                 </li>
//                 <li>
//                   <a href="#">services</a>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* Newsletter */}
//           <div className="col-lg-3 col-md-4">
//             <div className="footer-newsletter">
//               <h3>Subscribe to the Newsletters</h3>
//               <div className="footer-newsletter-form">
//                 <form id="newslettersForm" action="#" method="POST">
//                   <div className="form-group">
//                     <input
//                       type="email"
//                       name="email"
//                       className="form-control"
//                       id="mail"
//                       placeholder="Email ..."
//                       required
//                     />
//                     <button type="submit" className="section-icon-btn">
//                       <img src="images/arrow-white.svg" alt="Send" />
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer Copyright */}
//         <div className="footer-copyright">
//           <div className="row align-items-center">
//             <div className="col-lg-6 col-md-7">
//               <div className="footer-copyright-text">
//                 <p>© 2024 Novaride. All rights reserved.</p>
//               </div>
//             </div>
//             <div className="col-lg-6 col-md-5">
//               <div className="footer-social-links">
//                 <ul>
//                   <li>
//                     <a href="#">
//                       <i className="fa-brands fa-youtube"></i>
//                     </a>
//                   </li>
//                   <li>
//                     <a href="#">
//                       <i className="fa-brands fa-facebook-f"></i>
//                     </a>
//                   </li>
//                   <li>
//                     <a href="#">
//                       <i className="fa-brands fa-x-twitter"></i>
//                     </a>
//                   </li>
//                   <li>
//                     <a href="#">
//                       <i className="fa-brands fa-instagram"></i>
//                     </a>
//                   </li>
//                   <li>
//                     <a href="#">
//                       <i className="fa-brands fa-linkedin-in"></i>
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp
} from "react-icons/fa";

import { FaPinterest } from "react-icons/fa";
import { RiThreadsFill } from "react-icons/ri";
const Footer = () => {
  return (
    <footer className="tr_footer wow fadeIn">
      <div className="container">



        <div className="col-xl-12 col-md-sm-6">
          <div className="row">





            <div className="col-lg-4 col-md-4 col-12">
              <div className="footer_about mb-md-0 mb-5">
                <img src="/images/logo.png" alt="Tourin Logo" className='footlogo' />
                <div className="contact-item">
                  <span className="icon">
                    <h5 className="info-title text-white-color">Contact Us</h5>
                    <p>
                      <i className="fa-solid fa-phone"></i>
                      <a href="tel:+919730707888">+91 9730707888</a>
                    </p>
<p>
                      <i className="fa-solid fa-phone"></i>
                      <a href="tel:+919833377051">+91 9833377051</a>
                    </p>
                  </span>
                  <div className="info">

                    {/* <p>
                      <a href="mailto:bookings@aaryantravels.com">bookings@aaryantravels.com</a>
                    </p> */}
                  </div>
                </div>
                {/* <p>
                Aaryan Travels is your trusted partner for safe, reliable, and comfortable travel across all of India. Whether you're planning a pilgrimage, family vacation, corporate trip, or airport transfer, we provide well-maintained vehicles and professional chauffeurs to ensure a seamless and enjoyable journey wherever you go.
                </p> */}
                {/* <span>Connect with us</span> */}


<ul className="ah-social m-0 p-0 d-flex align-items-center gap-3">
  <li>
    <a href="https://www.facebook.com/aaryantravels15/" target="_blank" rel="noopener noreferrer">
      <FaFacebookF />
    </a>
  </li>

  {/* <li>
    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
      <FaTwitter />
    </a>
  </li> */}

  <li>
    <a href="https://wa.me/919730707888" target="_blank" rel="noopener noreferrer">
      <FaWhatsapp />
    </a>
  </li>

  <li>
    <a href="https://www.instagram.com/aaryan__travels/" target="_blank" rel="noopener noreferrer">
      <FaInstagram />
    </a>
  </li>

  <li>
    <a href="https://www.linkedin.com/company/108839473/" target="_blank" rel="noopener noreferrer">
      <FaLinkedinIn />
    </a>
  </li>

  <li>
    <a href="https://www.youtube.com/@aaryantravels" target="_blank" rel="noopener noreferrer">
      <FaYoutube />
    </a>
  </li>

  <li>
  <a
    href="https://www.threads.com/@aaryan__travels"
    target="_blank"
    rel="noopener noreferrer"
  >
    <RiThreadsFill />
  </a>
</li>

<li>
  <a
    href="https://in.pinterest.com/Aaryan__travels/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaPinterest />
  </a>
</li>
</ul>



      {/* <ul className="ah-social m-0 p-0 d-flex align-items-center gap-3">
            <li>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/facebook.png" alt="Facebook" className="social-icon" />
              </a>
            </li>
 <li>
    <a
      href="https://wa.me/919730707888"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/images/whatsap.png" alt="WhatsApp" className="social-icon" />
    </a>
  </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/instagram.png" alt="Instagram" className="social-icon" />
              </a>
            </li>

            <li>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/linkedin.png" alt="LinkedIn" className="social-icon" />
              </a>
            </li>

            <li>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/youtube.png" alt="YouTube" className="social-icon" />
              </a>
            </li>
          </ul> */}
             
{/* 
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.59615354253!2d73.8059866739396!3d18.662972364811374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b95422f24d2d%3A0x7c21580a69234261!2sAaryan%20Tours%20and%20Travels!5e1!3m2!1sen!2sin!4v1759920615579!5m2!1sen!2sin" width="270" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

              </div>
            </div>







<div className="col-xl-2 col-lg-4 col-md-6 col-12">
              <div className="footer_widget">
                <h3 className="footer-title">Quick Links</h3>
                <div className="footer_contact">
                 
                  <li>
                  <a href="/about">About Us</a>
                </li>
                <li>
                  <a href="/our-network">Our Network</a>
                </li>
                <li>
                  <a href="/services">Our Services</a>
                </li>
                  <li>
                  <a href="/gallery">Gallery</a>
                </li>

                
                 

                                  <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                  <li>
                  <a href="/contact-us">Contact Us</a>
                </li>
                  
               <Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-pune"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/best-cab-services-in-pune"><i className="fa fa-car darkcolo"></i> Best Cab Services in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/best-cab-services-in-kochi"><i className="fa fa-car darkcolo"></i> Best Cab Services in Kochi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/cab-booking-from-mumbai-to-pune"><i className="fa fa-car darkcolo"></i> Cab booking from Mumbai to Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/cab-from-pune-to-mahabaleshwar"><i className="fa fa-car darkcolo"></i> Cab from Pune to Mahabaleshwar</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-cab-hire-contract-in-hyderabad"><i className="fa fa-car darkcolo"></i> Monthly Cab hire contract in Hyderabad</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/taxi-services-from-pune-to-shirdi"><i className="fa fa-car darkcolo"></i> Taxi Services from Pune to Shirdi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/pune-to-shirdi-cab"><i className="fa fa-car darkcolo"></i> Pune to Shirdi Cab</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/mumbai-to-pune-corporate-cab"><i className="fa fa-car darkcolo"></i> Mumbai to Pune Corporate Cab</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/outstation-cab-services-from-pune"><i className="fa fa-car darkcolo"></i> Outstation Cab Services from Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/innova-crysta-rental-in-pune"><i className="fa fa-car darkcolo"></i> Innova Crysta rental in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-hire-in-pune"><i className="fa fa-car darkcolo"></i> Corporate Cab hire in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/pune-to-shirdi-corporate-cab-booking"><i className="fa fa-car darkcolo"></i> Pune to Shirdi Corporate Cab booking</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/pune-to-mumbai-corporate-cab-services"><i className="fa fa-car darkcolo"></i> Pune to Mumbai Corporate Cab Services</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-rental-in-chennai"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab rental in Chennai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/wedding-cab-bookings-in-pune"><i className="fa fa-car darkcolo"></i> Wedding Cab bookings in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-kharadi-pune"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in Kharadi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-ranchi"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in Ranchi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-vadodara"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in Vadodara</Link>
{/* <Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-booking-in-ranchi"><i className="fa fa-car darkcolo"></i> Corporate Cab booking in Ranchi</Link> */}
{/* <Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-booking-in-vadodara"><i className="fa fa-car darkcolo"></i> Corporate Cab booking in Vadodara</Link> */}
<Link className="mx-md-2 darkcoloo d-none" to="/taxi-booking-in-ranchi"><i className="fa fa-car darkcolo"></i> Taxi booking in Ranchi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-india"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in India</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/taxi-services-in-vadodara-gujarat"><i className="fa fa-car darkcolo"></i> Taxi Services in Vadodara</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/taxi-booking-in-vadodara"><i className="fa fa-car darkcolo"></i> Taxi booking in Vadodara</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/best-cab-services-in-hyderabad"><i className="fa fa-car darkcolo"></i> Best Cab Services in Hyderabad</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/cab-services-in-amritsar"><i className="fa fa-car darkcolo"></i> Cab Services in Amritsar</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/cab-booking-in-amritsar"><i className="fa fa-car darkcolo"></i> Cab booking in Amritsar</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/city-cab-services-in-amritsar"><i className="fa fa-car darkcolo"></i> City Cab Services in Amritsar</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-jalandhar"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in Jalandhar</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/amritsar-taxi-booking"><i className="fa fa-car darkcolo"></i> Amritsar Taxi booking</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-amritsar"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in Amritsar</Link>
               <Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-booking-in-ludhiana"><i className="fa fa-car darkcolo"></i> Corporate Cab booking in Ludhiana</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-services-in-gujarat"><i className="fa fa-car darkcolo"></i> Corporate Cab Services in Gujarat</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/leading-cab-companies-in-india"><i className="fa fa-car darkcolo"></i> Leading Cab Companies in India</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/car-rentals-with-drivers-in-mumbai"><i className="fa fa-car darkcolo"></i> Car Rentals with Drivers in Mumbai</Link>
 <Link className="mx-md-2 darkcoloo d-none" to="/outstation-cab-services-from-mumbai"><i className="fa fa-car darkcolo"></i> Outstation Cab Services from Mumbai</Link>

                </div>
              </div>
            </div>

          


            <div className="col-xl-2 col-lg-4 col-md-6 col-12">
              <div className="footer_widget">
                <h3 className="footer-title">Rides</h3>
                <div className="footer_contact">



                 
                  <li>
                  <a href="/sedan ">Sedan </a>
                </li>
                  <li>
                  <a href="/muv">MUV </a>
                </li>

                <li>
                  <a href="/premium ">Premium 
</a>
                </li>
                  <li>
                  <a href="/luxury"> Luxury </a>
                </li>
                <li>
                  <a href="/buses"> Buses </a>
                </li>
                <li>
                  <a href="/E-Vehicals"> E-vehicles
 </a>
                </li>




<Link className="mx-md-3 darkcoloo d-none" to="/monthly-vehicle-rentals-with-drivers-in-bangalore"><i className="fa fa-car darkcolo"></i> Monthly Vehicle Rentals with Drivers in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-sedan-rentals-with-drivers-in-pune"><i className="fa fa-car darkcolo"></i> Luxury Sedan Rentals with Drivers in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-car-and-driver-rentals-in-mumbai"><i className="fa fa-car darkcolo"></i> Monthly Car and Driver Rentals in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-cab-services-in-delhi"><i className="fa fa-car darkcolo"></i> Luxury Cab Services in Delhi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/trusted-corporate-cab-services-in-chennai"><i className="fa fa-car darkcolo"></i> Trusted Corporate Cab Services in Chennai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/affordable-corporate-cab-services-in-delhi"><i className="fa fa-car darkcolo"></i> Affordable Corporate Cab Services in Delhi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/budget-corporate-cab-services-in-kolkata"><i className="fa fa-car darkcolo"></i> Budget Corporate Cab Services in Kolkata</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/leading-cab-services-across-india"><i className="fa fa-car darkcolo"></i> Leading Cab Services across India</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-cab-rentals-in-india"><i className="fa fa-car darkcolo"></i> Luxury Cab Rentals in India</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-rentals-in-pune"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Rentals in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-hire-in-pune"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Hire in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/airport-cab-services-in-mumbai"><i className="fa fa-car darkcolo"></i> Airport Cab Services in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-cab-bookings-in-pune"><i className="fa fa-car darkcolo"></i> Luxury Cab Bookings in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/premium-corporate-cab-bookings-in-hyderabad"><i className="fa fa-car darkcolo"></i> Premium Corporate Cab Bookings in Hyderabad</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/innova-outstation-cab-rentals-from-pune"><i className="fa fa-car darkcolo"></i> Innova Outstation Cab Rentals from Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-plans-in-delhi"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Plans in Delhi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/one-month-corporate-cab-rentals-in-kolkata"><i className="fa fa-car darkcolo"></i> One Month Corporate Cab Rentals in Kolkata</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/one-month-rental-corporate-cab-services-in-chennai"><i className="fa fa-car darkcolo"></i> One Month Rental Corporate Cab Services in Chennai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/business-travel-cab-services-in-delhi"><i className="fa fa-car darkcolo"></i> Business Travel Cab Services in Delhi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/premium-cab-rentals-with-drivers-in-bangalore"><i className="fa fa-car darkcolo"></i> Premium Cab Rentals with Drivers in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/chauffeur-driven-premium-cabs-in-bangalore"><i className="fa fa-car darkcolo"></i> Chauffeur-Driven Premium Cabs in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/mercedes-rentals-with-drivers-in-delhi"><i className="fa fa-car darkcolo"></i> Mercedes Rentals with Drivers in Delhi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/mercedes-benz-cab-rentals-in-mumbai"><i className="fa fa-car darkcolo"></i> Mercedes Benz Cab Rentals in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-rentals-in-chennai"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Rentals in Chennai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-cab-rentals-with-drivers-in-pune"><i className="fa fa-car darkcolo"></i> Luxury Cab Rentals with Drivers in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-rentals-in-hyderabad"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Rentals in Hyderabad</Link>
               <Link className="mx-md-2 darkcoloo d-none" to="/long-term-corporate-cab-rentals-in-delhi"><i className="fa fa-car darkcolo"></i> Long-Term Corporate Cab Rentals in Delhi</Link>

                </div>
              </div>
            </div>



            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div className="footer_widget">
                <h3 className="footer-title">Location</h3>
                <div className="footer_contact">





                            <iframe
            width="260"
            height="210"
            loading="lazy"
            allowFullScreen
            style={{ borderRadius: "8px", marginTop: "15px" }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.59615354253!2d73.8059866739396!3d18.662972364811374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b95422f24d2d%3A0x7c21580a69234261!2sAaryan%20Tours%20and%20Travels!5e1!3m2!1sen!2sin!4v1759920615579!5m2!1sen!2sin"
          ></iframe>
<Link className="mx-md-2 darkcoloo d-none" to="/six-month-corporate-cab-rentals-in-mumbai"><i className="fa fa-car darkcolo"></i> Six-Month Corporate Cab Rentals in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-bookings-in-kolkata"><i className="fa fa-car darkcolo"></i> Corporate Cab Bookings in Kolkata</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-rentals-with-drivers-in-kolkata"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Rentals with Drivers in Kolkata</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-bookings-in-chennai"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Bookings in Chennai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-booking-services-in-mumbai"><i className="fa fa-car darkcolo"></i> Corporate Cab Booking Services in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-cab-rentals-in-pune"><i className="fa fa-car darkcolo"></i> Luxury Cab Rentals in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/bmw-cab-rentals-near-me-in-mumbai"><i className="fa fa-car darkcolo"></i> BMW Cab Rentals Near Me in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/corporate-cab-bookings-in-hyderabad"><i className="fa fa-car darkcolo"></i> Corporate Cab Bookings in Hyderabad</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/one-month-corporate-cab-rentals-in-bangalore"><i className="fa fa-car darkcolo"></i> One-Month Corporate Cab Rentals in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/bmw-rentals-with-drivers-in-delhi"><i className="fa fa-car darkcolo"></i> BMW Rentals with Drivers in Delhi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/yearly-corporate-cab-rentals-in-mumbai"><i className="fa fa-car darkcolo"></i> Yearly Corporate Cab Rentals in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/mercedes-cab-rentals-in-bangalore"><i className="fa fa-car darkcolo"></i> Mercedes Cab Rentals in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/monthly-corporate-cab-bookings-in-mumbai"><i className="fa fa-car darkcolo"></i> Monthly Corporate Cab Bookings in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/chauffeur-driven-mercedes-rentals-in-mumbai"><i className="fa fa-car darkcolo"></i> Chauffeur-Driven Mercedes Rentals in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/mercedes-benz-taxi-services-in-hyderabad"><i className="fa fa-car darkcolo"></i> Mercedes Benz Taxi Services in Hyderabad</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/vip-cab-services-in-chennai"><i className="fa fa-car darkcolo"></i> VIP Cab Services in Chennai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-taxi-rentals-in-pune"><i className="fa fa-car darkcolo"></i> Luxury Taxi Rentals in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/sports-cab-bookings-in-bangalore"><i className="fa fa-car darkcolo"></i> Sports Cab Bookings in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/outstation-cab-bookings-in-pune"><i className="fa fa-car darkcolo"></i> Outstation Cab Bookings in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-cab-rentals-in-mumbai"><i className="fa fa-car darkcolo"></i> Luxury Cab Rentals in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/wedding-luxury-cab-rentals-in-delhi"><i className="fa fa-car darkcolo"></i> Wedding Luxury Cab Rentals in Delhi</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/exotic-cab-bookings-in-kolkata"><i className="fa fa-car darkcolo"></i> Exotic Cab Bookings in Kolkata</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/mercedes-benz-rentals-with-drivers-in-chennai"><i className="fa fa-car darkcolo"></i> Mercedes Benz Rentals with Drivers in Chennai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/wedding-luxury-cab-rentals-in-bangalore"><i className="fa fa-car darkcolo"></i> Wedding Luxury Cab Rentals in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-car-rentals-with-drivers-in-hyderabad"><i className="fa fa-car darkcolo"></i> Luxury Car Rentals with Drivers in Hyderabad</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-van-rentals-with-drivers-in-mumbai"><i className="fa fa-car darkcolo"></i> Luxury Van Rentals with Drivers in Mumbai</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/cab-hire-services-in-pune"><i className="fa fa-car darkcolo"></i> Cab Hire Services in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/mercedes-chauffeur-services-in-bangalore"><i className="fa fa-car darkcolo"></i> Mercedes Chauffeur Services in Bangalore</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/premium-cab-rentals-in-pune"><i className="fa fa-car darkcolo"></i> Premium Cab Rentals in Pune</Link>
<Link className="mx-md-2 darkcoloo d-none" to="/luxury-cab-hire-for-weddings-in-delhi"><i className="fa fa-car darkcolo"></i> Luxury Cab Hire for Weddings in Delhi</Link>

                </div>
              </div>
            </div>

          </div>
        </div>



        <div className="row">
          <div className="col-12">
            <div className="tr_copyright text-center">
              <p className="copyright-text text-white">
                All Rights Reserved &copy;  <span className="darkcolor">Aaryan Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolor">&nbsp;Dexter Intelligence</span>
                </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolor">&nbsp;Urva Hosting</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   const [openCity, setOpenCity] = useState(null);

//   const toggleCity = (city) => {
//     setOpenCity(openCity === city ? null : city);
//   };

//   // ===============================================
//   // CITY-WISE FULL DATA (All keywords included)
//   // ===============================================
//   const cityServices = {
//     Pune: [
//       { name: "Corporate Cab Services in Pune", link: "/corporate-cab-services-in-pune" },
//       { name: "Best Cab Services in Pune", link: "/best-cab-services-in-pune" },
//       { name: "Innova Crysta rental in Pune", link: "/innova-crysta-rental-in-pune" },
//       { name: "Corporate Cab hire in Pune", link: "/corporate-cab-hire-in-pune" },
//       { name: "Pune to Shirdi Corporate Cab booking", link: "/pune-to-shirdi-corporate-cab-booking" },
//       { name: "Pune to Mumbai Corporate Cab Services", link: "/pune-to-mumbai-corporate-cab-services" },
//       { name: "Wedding Cab bookings in Pune", link: "/wedding-cab-bookings-in-pune" },
//       { name: "Corporate Cab Services in Kharadi", link: "/corporate-cab-services-in-kharadi-pune" },
//       { name: "Outstation Cab Bookings in Pune", link: "/outstation-cab-bookings-in-pune" },
//       { name: "Luxury Cab Rentals in Pune", link: "/luxury-cab-rentals-in-pune" },
//       { name: "Premium Cab Rentals in Pune", link: "/premium-cab-rentals-in-pune" },
//       { name: "Luxury Taxi Rentals in Pune", link: "/luxury-taxi-rentals-in-pune" },
//       { name: "Cab Hire Services in Pune", link: "/cab-hire-services-in-pune" },
//       { name: "Monthly Corporate Cab Rentals in Pune", link: "/monthly-corporate-cab-rentals-in-pune" },
//     ],

//     Mumbai: [
//       { name: "Car Rentals with Drivers in Mumbai", link: "/car-rentals-with-drivers-in-mumbai" },
//       { name: "Outstation Cab Services from Mumbai", link: "/outstation-cab-services-from-mumbai" },
//       { name: "Airport Cab Services in Mumbai", link: "/airport-cab-services-in-mumbai" },
//       { name: "Luxury Cab Rentals in Mumbai", link: "/luxury-cab-rentals-in-mumbai" },
//       { name: "Corporate Cab Booking Services in Mumbai", link: "/corporate-cab-booking-services-in-mumbai" },
//       { name: "BMW Cab Rentals Near Me in Mumbai", link: "/bmw-cab-rentals-near-me-in-mumbai" },
//       { name: "Yearly Corporate Cab Rentals in Mumbai", link: "/yearly-corporate-cab-rentals-in-mumbai" },
//       { name: "Monthly Corporate Cab Bookings in Mumbai", link: "/monthly-corporate-cab-bookings-in-mumbai" },
//       { name: "Chauffeur Driven Mercedes Rentals in Mumbai", link: "/chauffeur-driven-mercedes-rentals-in-mumbai" },
//       { name: "Luxury Van Rentals with Drivers in Mumbai", link: "/luxury-van-rentals-with-drivers-in-mumbai" },
//     ],

//     Bangalore: [
//       { name: "Monthly Vehicle Rentals with Drivers in Bangalore", link: "/monthly-vehicle-rentals-with-drivers-in-bangalore" },
//       { name: "Premium Cab Rentals with Drivers in Bangalore", link: "/premium-cab-rentals-with-drivers-in-bangalore" },
//       { name: "Chauffeur Driven Premium Cabs in Bangalore", link: "/chauffeur-driven-premium-cabs-in-bangalore" },
//       { name: "Mercedes Cab Rentals in Bangalore", link: "/mercedes-cab-rentals-in-bangalore" },
//       { name: "Sports Cab Bookings in Bangalore", link: "/sports-cab-bookings-in-bangalore" },
//       { name: "One Month Corporate Cab Rentals in Bangalore", link: "/one-month-corporate-cab-rentals-in-bangalore" },
//       { name: "Mercedes Chauffeur Services in Bangalore", link: "/mercedes-chauffeur-services-in-bangalore" },
//     ],

//     Chennai: [
//       { name: "Trusted Corporate Cab Services in Chennai", link: "/trusted-corporate-cab-services-in-chennai" },
//       { name: "Monthly Corporate Cab Rentals in Chennai", link: "/monthly-corporate-cab-rentals-in-chennai" },
//       { name: "Monthly Corporate Cab Bookings in Chennai", link: "/monthly-corporate-cab-bookings-in-chennai" },
//       { name: "Mercedes Benz Rentals with Drivers in Chennai", link: "/mercedes-benz-rentals-with-drivers-in-chennai" },
//       { name: "One Month Rental Corporate Cab Services in Chennai", link: "/one-month-rental-corporate-cab-services-in-chennai" },
//       { name: "VIP Cab Services in Chennai", link: "/vip-cab-services-in-chennai" },
//     ],

//     Delhi: [
//       { name: "Luxury Cab Services in Delhi", link: "/luxury-cab-services-in-delhi" },
//       { name: "Affordable Corporate Cab Services in Delhi", link: "/affordable-corporate-cab-services-in-delhi" },
//       { name: "Business Travel Cab Services in Delhi", link: "/business-travel-cab-services-in-delhi" },
//       { name: "Mercedes Rentals with Drivers in Delhi", link: "/mercedes-rentals-with-drivers-in-delhi" },
//       { name: "Long-Term Corporate Cab Rentals in Delhi", link: "/long-term-corporate-cab-rentals-in-delhi" },
//       { name: "Luxury Cab Hire for Weddings in Delhi", link: "/luxury-cab-hire-for-weddings-in-delhi" },
//     ],

//     Hyderabad: [
//       { name: "Premium Corporate Cab Bookings in Hyderabad", link: "/premium-corporate-cab-bookings-in-hyderabad" },
//       { name: "Mercedes Benz Taxi Services in Hyderabad", link: "/mercedes-benz-taxi-services-in-hyderabad" },
//       { name: "Corporate Cab Bookings in Hyderabad", link: "/corporate-cab-bookings-in-hyderabad" },
//       { name: "Monthly Corporate Cab Rentals in Hyderabad", link: "/monthly-corporate-cab-rentals-in-hyderabad" },
//       { name: "Monthly Cab Hire Contract in Hyderabad", link: "/monthly-cab-hire-contract-in-hyderabad" },
//       { name: "Best Cab Services in Hyderabad", link: "/best-cab-services-in-hyderabad" },
//     ],

//     Kolkata: [
//       { name: "Corporate Cab Bookings in Kolkata", link: "/corporate-cab-bookings-in-kolkata" },
//       { name: "Budget Corporate Cab Services in Kolkata", link: "/budget-corporate-cab-services-in-kolkata" },
//       { name: "Monthly Corporate Cab Rentals with Drivers in Kolkata", link: "/monthly-corporate-cab-rentals-with-drivers-in-kolkata" },
//       { name: "Exotic Cab Bookings in Kolkata", link: "/exotic-cab-bookings-in-kolkata" },
//     ],

//     Gujarat: [
//       { name: "Corporate Cab Services in Gujarat", link: "/corporate-cab-services-in-gujarat" },
//       { name: "Corporate Cab Services in Vadodara", link: "/corporate-cab-services-in-vadodara" },
//       { name: "Taxi Services in Vadodara", link: "/taxi-services-in-vadodara-gujarat" },
//       { name: "Taxi booking in Vadodara", link: "/taxi-booking-in-vadodara" },
//     ],

//     Punjab: [
//       { name: "Corporate Cab Services in Jalandhar", link: "/corporate-cab-services-in-jalandhar" },
//       { name: "Corporate Cab Services in Amritsar", link: "/corporate-cab-services-in-amritsar" },
//       { name: "Taxi booking in Amritsar", link: "/cab-booking-in-amritsar" },
//       { name: "City Cab Services in Amritsar", link: "/city-cab-services-in-amritsar" },
//       { name: "Amritsar Taxi booking", link: "/amritsar-taxi-booking" },
//       { name: "Corporate Cab booking in Ludhiana", link: "/corporate-cab-booking-in-ludhiana" },
//     ],

//     India: [
//       { name: "Corporate Cab Services in India", link: "/corporate-cab-services-in-india" },
//       { name: "Leading Cab Companies in India", link: "/leading-cab-companies-in-india" },
//       { name: "Luxury Cab Rentals in India", link: "/luxury-cab-rentals-in-india" },
//       { name: "Innova Outstation Cab Rentals from Pune", link: "/innova-outstation-cab-rentals-from-pune" },
//       { name: "Leading Cab Services across India", link: "/leading-cab-services-across-india" },
//     ],
//   };

//   // ==========================================================
//   // FOOTER MARKUP
//   // ==========================================================
//   return (
//     <footer className="corporate-footer">
//       <div className="footer-container">

//     {/* LEFT SECTION */}
// <div className="footer-left">
//   <img src="/images/logo.jpg" className="footer-logo" alt="Aaryan Travels" />

//   <h4>Contact Us</h4>
//   <p>
//     <i className="fa fa-phone"></i> 
//     <a href="tel:+919730707888" className="text-white">+91 9730707888</a>
//   </p>
//   <p>
//     <i className="fa fa-phone"></i> 
//     <a href="tel:+91983377051" className="text-white">+91 9833377051</a>
//   </p>
//   <p>
//     <i className="fa fa-envelope"></i>
//     <a href="mailto:bookings@aaryantravels.com" className="text-white">
//       bookings@aaryantravels.com
//     </a>
//   </p>

//   <p className="footer-desc">
//     Aaryan Travels provides premium corporate transportation across India with 
//     luxury cabs, chauffeur-driven cars, and dedicated corporate travel solutions.
//   </p>

//   {/* SOCIAL ICONS */}
//   <div className="footer-social d-flex gap-3 mt-3">
//     <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
//       <i className="fa-brands fa-facebook-f text-white"></i>
//     </a>
//     <a href="https://wa.me/919730707888" target="_blank" rel="noopener noreferrer">
//       <i className="fa-brands fa-whatsapp text-white"></i>
//     </a>
//     <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
//       <i className="fa-brands fa-instagram text-white"></i>
//     </a>
//     <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
//       <i className="fa-brands fa-youtube text-white"></i>
//     </a>
//   </div>

//   <iframe
//     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.59615354253!2d73.8059866739396!3d18.662972364811374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b95422f24d2d%3A0x7c21580a69234261!2sAaryan%20Tours%20and%20Travels!5e1!3m2!1sen!2sin!4v1759920615579!5m2!1sen!2sin"
//     width="270"
//     height="250"
//     allowFullScreen=""
//     loading="lazy"
//     referrerPolicy="no-referrer-when-downgrade"
//   ></iframe>
// </div>


//         {/* RIGHT SECTION – CITY ACCORDION */}
//         <div className="footer-right">
//           <h3 className="footer-heading">City-wise Corporate Cab Services</h3>

//           {Object.keys(cityServices).map((city) => (
//             <div key={city} className="city-section">
//               <div className="city-header" onClick={() => toggleCity(city)}>
//                 <span>{city}</span>
//                 <i className={`fa ${openCity === city ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
//               </div>

//               {openCity === city && (
//                 <div className="city-links">
//                   {cityServices[city].map((service, index) => (
//                     <Link
//                       key={index}
//                       className="footer-link"
//                       to={service.link}
//                     >
//                       <i className="fa fa-car"></i> {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* COPYRIGHT */}
//       <div className="footer-bottom">
//         <p>
//           © {new Date().getFullYear()} Aaryan Travels — Developed by{" "}
//           <a href="https://www.dexterintelligence.com" target="_blank">Dexter Intelligence</a>
//         </p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;





// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// const Footer = () => {

//   const [activeCity, setActiveCity] = useState("Mumbai");

//   const toggleCity = (city) => {
//     setActiveCity(city);
//   };

//   // ============================
//   // CITY-WISE FULL KEYWORDS
//   // ============================
//   const cityServices = {

//     Mumbai: [
//       { name: "Corporate Cab Services in Mumbai", link: "/corporate-cab-services-in-mumbai" },
//       { name: "Corporate cab services in Navi Mumbai MIDC", link: "/corporate-cab-services-in-navi-mumbai" },
//       { name: "Corporate Cab Services in Powai MIDC Mumbai", link: "/corporate-cab-services-in-powai" },
//       { name: "Corporate Cab Services in Airoli Mumbai", link: "/corporate-cab-services-in-airoli" },
//       { name: "Corporate Cab Service in Palghar MIDC", link: "/corporate-cab-service-in-palghar" },
//       { name: "Corporate cab services in Thane", link: "/corporate-cab-services-in-thane" },
//       { name: "Corporate cab services in Bhiwandi and Taloja MIDC", link: "/corporate-cab-services-in-bhiwandi" },
//       { name: "Mumbai Airport Corporate Cab Services", link: "/mumbai-airport-corporate-cab-services" },
//       { name: "Corporate Car Rental in Turbhe MIDC", link: "/corporate-car-rental-in-turbhe" },
//       { name: "Cab Service in Marol MIDC Andheri", link: "/cab-service-in-marol" },
//       { name: "Corporate Cab Services Panvel MIDC", link: "/corporate-cab-services-panvel" },
//       { name: "Cab Service in Mahape Navi Mumbai", link: "/cab-service-in-mahape" },
//       { name: "Corporate Cab Services in Navi Mumbai Airport", link: "/corporate-cab-services-in-navi-mumbai-airport" },
//       { name: "Corporate Cab Services for Corporate Events in Mumbai", link: "/corporate-events-cab-services-mumbai" },
//     ],

//     Pune: [
//       { name: "Corporate Cab Services in Pune", link: "/corporate-cab-services-in-pune" },
//       { name: "Best Cab Services in Pune", link: "/best-cab-services-in-pune" },
//       { name: "Innova Crysta rental in Pune", link: "/innova-crysta-rental-in-pune" },
//       { name: "Corporate Cab hire in Pune", link: "/corporate-cab-hire-in-pune" },
//       { name: "Pune to Shirdi Corporate Cab booking", link: "/pune-to-shirdi-corporate-cab-booking" },
//       { name: "Pune to Mumbai Corporate Cab Services", link: "/pune-to-mumbai-corporate-cab-services" },
//       { name: "Wedding Cab bookings in Pune", link: "/wedding-cab-bookings-in-pune" },
//       { name: "Corporate Cab Services in Kharadi", link: "/corporate-cab-services-in-kharadi-pune" },
//       { name: "Outstation Cab Bookings in Pune", link: "/outstation-cab-bookings-in-pune" },
//       { name: "Luxury Cab Rentals in Pune", link: "/luxury-cab-rentals-in-pune" },
//       { name: "Premium Cab Rentals in Pune", link: "/premium-cab-rentals-in-pune" },
//       { name: "Luxury Taxi Rentals in Pune", link: "/luxury-taxi-rentals-in-pune" },
//       { name: "Cab Hire Services in Pune", link: "/cab-hire-services-in-pune" },
//       { name: "Monthly Corporate Cab Rentals in Pune", link: "/monthly-corporate-cab-rentals-in-pune" },
//     ],

//     Delhi: [
//       { name: "Luxury Cab Services in Delhi", link: "/luxury-cab-services-in-delhi" },
//       { name: "Affordable Corporate Cab Services in Delhi", link: "/affordable-corporate-cab-services-in-delhi" },
//       { name: "Business Travel Cab Services in Delhi", link: "/business-travel-cab-services-in-delhi" },
//       { name: "Mercedes Rentals with Drivers in Delhi", link: "/mercedes-rentals-with-drivers-in-delhi" },
//       { name: "Long-Term Corporate Cab Rentals in Delhi", link: "/long-term-corporate-cab-rentals-in-delhi" },
//       { name: "Luxury Cab Hire for Weddings in Delhi", link: "/luxury-cab-hire-for-weddings-in-delhi" },
//     ],

//     Bangalore: [
//       { name: "Monthly Vehicle Rentals with Drivers in Bangalore", link: "/monthly-vehicle-rentals-with-drivers-in-bangalore" },
//       { name: "Premium Cab Rentals with Drivers in Bangalore", link: "/premium-cab-rentals-with-drivers-in-bangalore" },
//       { name: "Chauffeur Driven Premium Cabs in Bangalore", link: "/chauffeur-driven-premium-cabs-in-bangalore" },
//       { name: "Mercedes Cab Rentals in Bangalore", link: "/mercedes-cab-rentals-in-bangalore" },
//       { name: "One Month Corporate Cab Rentals in Bangalore", link: "/one-month-corporate-cab-rentals-in-bangalore" },
//       { name: "Mercedes Chauffeur Services in Bangalore", link: "/mercedes-chauffeur-services-in-bangalore" },
//     ],

//     Hyderabad: [
//       { name: "Premium Corporate Cab Bookings in Hyderabad", link: "/premium-corporate-cab-bookings-in-hyderabad" },
//       { name: "Mercedes Benz Taxi Services in Hyderabad", link: "/mercedes-benz-taxi-services-in-hyderabad" },
//       { name: "Corporate Cab Bookings in Hyderabad", link: "/corporate-cab-bookings-in-hyderabad" },
//       { name: "Monthly Corporate Cab Rentals in Hyderabad", link: "/monthly-corporate-cab-rentals-in-hyderabad" },
//       { name: "Monthly Cab Hire Contract in Hyderabad", link: "/monthly-cab-hire-contract-in-hyderabad" },
//       { name: "Best Cab Services in Hyderabad", link: "/best-cab-services-in-hyderabad" },
//     ],

//     Kolkata: [
//       { name: "Corporate Cab Bookings in Kolkata", link: "/corporate-cab-bookings-in-kolkata" },
//       { name: "Budget Corporate Cab Services in Kolkata", link: "/budget-corporate-cab-services-in-kolkata" },
//       { name: "Monthly Corporate Cab Rentals with Drivers in Kolkata", link: "/monthly-corporate-cab-rentals-with-drivers-in-kolkata" },
//       { name: "Exotic Cab Bookings in Kolkata", link: "/exotic-cab-bookings-in-kolkata" },
//     ],

//     Gujarat: [
//       { name: "Corporate Cab Services in Gujarat", link: "/corporate-cab-services-in-gujarat" },
//       { name: "Corporate Cab Services in Vadodara", link: "/corporate-cab-services-in-vadodara" },
//       { name: "Taxi Services in Vadodara", link: "/taxi-services-in-vadodara-gujarat" },
//       { name: "Taxi booking in Vadodara", link: "/taxi-booking-in-vadodara" },
//     ],

//     Punjab: [
//       { name: "Corporate Cab Services in Jalandhar", link: "/corporate-cab-services-in-jalandhar" },
//       { name: "Corporate Cab Services in Amritsar", link: "/corporate-cab-services-in-amritsar" },
//       { name: "Taxi booking in Amritsar", link: "/cab-booking-in-amritsar" },
//       { name: "City Cab Services in Amritsar", link: "/city-cab-services-in-amritsar" },
//       { name: "Amritsar Taxi booking", link: "/amritsar-taxi-booking" },
//       { name: "Corporate Cab booking in Ludhiana", link: "/corporate-cab-booking-in-ludhiana" },
//     ],

//     India: [
//       { name: "Corporate Cab Services in India", link: "/corporate-cab-services-in-india" },
//       { name: "Leading Cab Companies in India", link: "/leading-cab-companies-in-india" },
//       { name: "Luxury Cab Rentals in India", link: "/luxury-cab-rentals-in-india" },
//       { name: "Innova Outstation Cab Rentals from Pune", link: "/innova-outstation-cab-rentals-from-pune" },
//       { name: "Leading Cab Services across India", link: "/leading-cab-services-across-india" },
//     ],
//   };

//   return (
//     <footer className="big-footer">

//       <div className="footer-container">

//         {/* ========================================
//             LEFT SIDE (LOGO + CONTACT + MAP)
//         ========================================== */}
//         <div className="footer-left">

//           <img src="/images/logo.jpg" alt="Aaryan Travels" className="footer-logo" />

//           <p><i className="fa fa-envelope"></i> bookings@aaryantravels.com</p>
//           <p><i className="fa fa-phone"></i> +91 9730707888</p>
//           <p><i className="fa fa-phone"></i> +91 9833377051</p>

//           <iframe
//             width="260"
//             height="230"
//             loading="lazy"
//             allowFullScreen
//             style={{ borderRadius: "8px", marginTop: "15px" }}
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.59615354253!2d73.8059866739396!3d18.662972364811374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b95422f24d2d%3A0x7c21580a69234261!2sAaryan%20Tours%20and%20Travels!5e1!3m2!1sen!2sin!4v1759920615579!5m2!1sen!2sin"
//           ></iframe>

//         </div>

//         {/* ========================================
//             RIGHT SIDE (CITY BUTTONS + SERVICE GRID)
//         ========================================== */}
//         <div className="footer-right">

//           <h2 className="service-title">Our Service Locations</h2>

//           <div className="city-buttons">
//             {Object.keys(cityServices).map((city) => (
//               <button
//                 key={city}
//                 className={`city-btn ${activeCity === city ? "active" : ""}`}
//                 onClick={() => toggleCity(city)}
//               >
//                 {city}
//               </button>
//             ))}
//           </div>

//           <h3 className="city-heading">{activeCity} Services</h3>

//           {/* 4 Columns Like Screenshot */}
//           <div className="service-grid-4">
//             {cityServices[activeCity].map((srv, i) => (
//               <Link key={i} to={srv.link} className="service-link">
//                 <i className="fa fa-car"></i> {srv.name}
//               </Link>
//             ))}
//           </div>

//         </div>

//       </div>

//     </footer>
//   );
// };

// export default Footer;






















// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// const Footer = () => {

//   const [activeCity, setActiveCity] = useState("Mumbai");

//   const toggleCity = (city) => {
//     setActiveCity(city);
//   };

//   // ============================================
//   // CITY-WISE KEYWORDS
//   // ============================================


// // Cities to HIDE from footer UI (SEO stays)
// const hiddenCities = [
//   "Bhopal",
//   "Indore",
//   "Kochi",
//   "Trivandrum",
//   "Coimbatore",
//   "Madurai",
//   "Jaipur",
//   "Udaipur",
//   "Ahmedabad"
// ];



//   const cityServices = {
//     Mumbai: [
//       { name: "Corporate Cab Services in Mumbai", link: "/corporate-cab-services-in-mumbai" },
//       { name: "Corporate cab services in Navi Mumbai MIDC", link: "/corporate-cab-services-in-navi-mumbai" },
//       { name: "Corporate Cab Services in Powai MIDC Mumbai", link: "/corporate-cab-services-in-powai" },
//       { name: "Corporate Cab Services in Airoli Mumbai", link: "/corporate-cab-services-in-airoli" },
//       { name: "Corporate Cab Service in Palghar MIDC", link: "/corporate-cab-service-in-palghar" },
//       { name: "Corporate cab services in Thane", link: "/corporate-cab-services-in-thane" },
//       { name: "Corporate cab services in Bhiwandi and Taloja MIDC", link: "/corporate-cab-services-in-bhiwandi" },
//       { name: "Mumbai Airport Corporate Cab Services", link: "/mumbai-airport-corporate-cab-services" },
//       { name: "Corporate Car Rental in Turbhe MIDC", link: "/corporate-car-rental-in-turbhe" },
//       { name: "Cab Service in Marol MIDC Andheri", link: "/cab-service-in-marol" },
//       { name: "Corporate Cab Services Panvel MIDC", link: "/corporate-cab-services-panvel" },
//       { name: "Cab Service in Mahape Navi Mumbai", link: "/cab-service-in-mahape" },
//       { name: "Corporate Cab Services in Navi Mumbai Airport", link: "/corporate-cab-services-in-navi-mumbai-airport" },
//       { name: "Corporate Cab Services for Corporate Events in Mumbai", link: "/corporate-events-cab-services-mumbai" },
//     ],

//     Pune: [
//       { name: "Corporate Cab Services in Pune", link: "/corporate-cab-services-in-pune" },
//       { name: "Best Cab Services in Pune", link: "/best-cab-services-in-pune" },
//       { name: "Innova Crysta rental in Pune", link: "/innova-crysta-rental-in-pune" },
//       { name: "Corporate Cab hire in Pune", link: "/corporate-cab-hire-in-pune" },
//       { name: "Pune to Shirdi Corporate Cab booking", link: "/pune-to-shirdi-corporate-cab-booking" },
//       { name: "Pune to Mumbai Corporate Cab Services", link: "/pune-to-mumbai-corporate-cab-services" },
//       { name: "Wedding Cab bookings in Pune", link: "/wedding-cab-bookings-in-pune" },
//       { name: "Corporate Cab Services in Kharadi", link: "/corporate-cab-services-in-kharadi-pune" },
//       { name: "Outstation Cab Bookings in Pune", link: "/outstation-cab-bookings-in-pune" },
//       { name: "Luxury Cab Rentals in Pune", link: "/luxury-cab-rentals-in-pune" },
//       { name: "Premium Cab Rentals in Pune", link: "/premium-cab-rentals-in-pune" },
//       { name: "Luxury Taxi Rentals in Pune", link: "/luxury-taxi-rentals-in-pune" },
//       { name: "Cab Hire Services in Pune", link: "/cab-hire-services-in-pune" },
//       { name: "Monthly Corporate Cab Rentals in Pune", link: "/monthly-corporate-cab-rentals-in-pune" },
//     ],

//     Delhi: [
//       { name: "Luxury Cab Services in Delhi", link: "/luxury-cab-services-in-delhi" },
//       { name: "Affordable Corporate Cab Services in Delhi", link: "/affordable-corporate-cab-services-in-delhi" },
//       { name: "Business Travel Cab Services in Delhi", link: "/business-travel-cab-services-in-delhi" },
//       { name: "Mercedes Rentals with Drivers in Delhi", link: "/mercedes-rentals-with-drivers-in-delhi" },
//       { name: "Long-Term Corporate Cab Rentals in Delhi", link: "/long-term-corporate-cab-rentals-in-delhi" },
//       { name: "Luxury Cab Hire for Weddings in Delhi", link: "/luxury-cab-hire-for-weddings-in-delhi" },
//     ],

//     Bangalore: [
//       { name: "Monthly Vehicle Rentals with Drivers in Bangalore", link: "/monthly-vehicle-rentals-with-drivers-in-banglore" },
//       { name: "Premium Cab Rentals with Drivers in Bangalore", link: "/premium-cab-rentals-with-drivers-in-banglore" },
//       { name: "Chauffeur Driven Premium Cabs in Bangalore", link: "/chauffeur-driven-premium-cabs-in-banglore" },
//       { name: "Mercedes Cab Rentals in Bangalore", link: "/mercedes-cab-rentals-in-banglore" },
//       { name: "One Month Corporate Cab Rentals in Bangalore", link: "/one-month-corporate-cab-rentals-in-banglore" },
//       { name: "Mercedes Chauffeur Services in Bangalore", link: "/mercedes-chauffeur-services-in-banglore" },
//     ],

//     Hyderabad: [
//       { name: "Premium Corporate Cab Bookings in Hyderabad", link: "/premium-corporate-cab-bookings-in-hyderabad" },
//       { name: "Mercedes Benz Taxi Services in Hyderabad", link: "/mercedes-benz-taxi-services-in-hyderabad" },
//       { name: "Corporate Cab Bookings in Hyderabad", link: "/corporate-cab-bookings-in-hyderabad" },
//       { name: "Monthly Corporate Cab Rentals in Hyderabad", link: "/monthly-corporate-cab-rentals-in-hyderabad" },
//       { name: "Monthly Cab Hire Contract in Hyderabad", link: "/monthly-cab-hire-contract-in-hyderabad" },
//       { name: "Best Cab Services in Hyderabad", link: "/best-cab-services-in-hyderabad" },
//     ],












//     Chennai: [
//       { name: "Trusted Corporate Cab Services in Chennai", link: "/trusted-corporate-cab-services-in-chennai" },
//       { name: "Monthly Corporate Cab Rentals in Chennai", link: "/monthly-corporate-cab-rentals-in-chennai" },
//       { name: "Monthly Corporate Cab Bookings in Chennai", link: "/monthly-corporate-cab-bookings-in-chennai" },
//       { name: "Mercedes Benz Rentals with Drivers in Chennai", link: "/mercedes-benz-rentals-with-drivers-in-chennai" },
//       { name: "One Month Rental Corporate Cab Services in Chennai", link: "/one-month-rental-corporate-cab-services-in-chennai" },
//       { name: "VIP Cab Services in Chennai", link: "/vip-cab-services-in-chennai" },
//     ],

//     Delhi: [
//       { name: "Luxury Cab Services in Delhi", link: "/luxury-cab-services-in-delhi" },
//       { name: "Affordable Corporate Cab Services in Delhi", link: "/affordable-corporate-cab-services-in-delhi" },
//       { name: "Business Travel Cab Services in Delhi", link: "/business-travel-cab-services-in-delhi" },
//       { name: "Mercedes Rentals with Drivers in Delhi", link: "/mercedes-rentals-with-drivers-in-delhi" },
//       { name: "Long-Term Corporate Cab Rentals in Delhi", link: "/long-term-corporate-cab-rentals-in-delhi" },
//       { name: "Luxury Cab Hire for Weddings in Delhi", link: "/luxury-cab-hire-for-weddings-in-delhi" },
//     ],

//     Kolkata: [
//       { name: "Corporate Cab Bookings in Kolkata", link: "/corporate-cab-bookings-in-kolkata" },
//       { name: "Budget Corporate Cab Services in Kolkata", link: "/budget-corporate-cab-services-in-kolkata" },
//       { name: "Monthly Corporate Cab Rentals with Drivers in Kolkata", link: "/monthly-corporate-cab-rentals-with-drivers-in-kolkata" },
//       { name: "Exotic Cab Bookings in Kolkata", link: "/exotic-cab-bookings-in-kolkata" },
//     ],

  

//    Vadodara: [
//       { name: "Corporate Cab Services in Gujarat", link: "/corporate-cab-services-in-gujarat" },
//       { name: "Corporate Cab Services in Vadodara", link: "/corporate-cab-services-in-vadodara" },
//       { name: "Taxi Services in Vadodara", link: "/taxi-services-in-vadodara-gujarat" },
//       { name: "Taxi booking in Vadodara", link: "/taxi-booking-in-vadodara" },
//     ],


// Amritsar:  [
//       { name: "Corporate Cab Services in Amritsar", link: "/corporate-cab-services-in-amritsar" },
//       { name: "Taxi booking in Amritsar", link: "/cab-booking-in-amritsar" },
//       { name: "City Cab Services in Amritsar", link: "/city-cab-services-in-amritsar" },
//       { name: "Amritsar Taxi booking", link: "/amritsar-taxi-booking" },
//     ],

//     Ludhiana: [
//       { name: "Corporate Cab Services in Jalandhar", link: "/corporate-cab-services-in-jalandhar" },
//       { name: "Corporate Cab booking in Ludhiana", link: "/corporate-cab-booking-in-ludhiana" },
//     ],

//     India: [
//       { name: "Corporate Cab Services in India", link: "/corporate-cab-services-in-india" },
//       { name: "Leading Cab Companies in India", link: "/leading-cab-companies-in-india" },
//       { name: "Luxury Cab Rentals in India", link: "/luxury-cab-rentals-in-india" },
//       { name: "Innova Outstation Cab Rentals from Pune", link: "/innova-outstation-cab-rentals-from-pune" },
//       { name: "Leading Cab Services across India", link: "/leading-cab-services-across-india" },
//     ],









//   };

//   // ============================================
//   // HEADER BUTTONS (NEW + EQUAL WIDTH)
//   // ============================================
//   const headerButtons = [
//     { name: "Pune" },
//     { name: "Mumbai" },
//     { name: "Delhi" },
//     { name: "Bangalore" },
//     { name: "Chennai" },
//     { name: "Hyderabad" },
//     { name: "Kolkata" },
//     // { name: "Gujarat" },
//     { name: "Vadodara" },
//     { name: "Ludhiana" },
//     { name: "Amritsar" },
//     { name: "Indore" },
//     { name: "Bhopal" },
//     { name: "Kochi" },
   

//     // EXTRA BUTTONS YOU WANT
//     { name: "About Us", link: "/about" },
//     { name: "Services", link: "/services" },
//     { name: "Contact Us", link: "/contact-us" },
//     { name: "Gallery", link: "/gallery" },
//   ];

//   return (
//     <footer className="big-footer">
//       <div className="footer-container">

//         {/* LEFT SECTION */}
//         <div className="footer-left">
//           <img src="/images/logo.jpg" className="footer-logo" alt="Aaryan Travels" />

//           <p><i className="fa fa-envelope"></i> bookings@aaryantravels.com</p>
//           <p><i className="fa fa-phone"></i> +91 9730707888</p>
//           <p><i className="fa fa-phone"></i> +91 9833377051</p>

//       <ul className="ah-social m-0 p-0 d-flex align-items-center gap-3">
//             <li>
//               <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/facebook.png" alt="Facebook" className="social-icon" />
//               </a>
//             </li>
//  <li>
//     <a
//       href="https://wa.me/919730707888"
//       target="_blank"
//       rel="noopener noreferrer"
//     >
//       <img src="/images/whatsap.png" alt="WhatsApp" className="social-icon" />
//     </a>
//   </li>
//             <li>
//               <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/instagram.png" alt="Instagram" className="social-icon" />
//               </a>
//             </li>

//             <li>
//               <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/linkedin.png" alt="LinkedIn" className="social-icon" />
//               </a>
//             </li>

//             <li>
//               <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
//                 <img src="/images/youtube.png" alt="YouTube" className="social-icon" />
//               </a>
//             </li>
//           </ul>

          // <iframe
          //   width="260"
          //   height="230"
          //   loading="lazy"
          //   allowFullScreen
          //   style={{ borderRadius: "8px", marginTop: "15px" }}
          //   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.59615354253!2d73.8059866739396!3d18.662972364811374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b95422f24d2d%3A0x7c21580a69234261!2sAaryan%20Tours%20and%20Travels!5e1!3m2!1sen!2sin!4v1759920615579!5m2!1sen!2sin"
          // ></iframe>


      
//         </div>

//         {/* RIGHT SECTION */}
//         <div className="footer-right">

//           <h2 className="service-title text-white">Our Service Locations</h2>

//           {/* Top Row Buttons */}
//           <div className="city-buttons">
//             {headerButtons.map((btn, index) => (
//               <button
//                 key={index}
//                 className={`city-btn ${activeCity === btn.name ? "active" : ""}`}
//                 onClick={() => btn.link ? window.location.href = btn.link : setActiveCity(btn.name)}
//               >
//                 {btn.name}
//               </button>
//             ))}
//           </div>

//           {/* <h3 className="city-heading">{activeCity} Services</h3> */}

//           <div className="service-grid-4">
//             {cityServices[activeCity]?.map((srv, i) => (
//               <Link key={i} to={srv.link} className="service-link d-none">
//                 <i className="fa fa-car"></i> {srv.name}
//               </Link>
//             ))}
//           </div>

//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
